module.exports = __webpack_public_path__ + "img/20187.7ed35120.png";